import { ROUTE_BASE } from 'apps-common'

export const isUrl = (url: string) => url.startsWith('http://') || url.startsWith('https://') || url.startsWith('://')

export const isExternalPath = (url: string) => !url.startsWith(`/${ROUTE_BASE.learner}`)
